import { render, staticRenderFns } from "./PageFile.vue?vue&type=template&id=51016d2a&"
import script from "./PageFile.vue?vue&type=script&lang=js&"
export * from "./PageFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51016d2a')) {
      api.createRecord('51016d2a', component.options)
    } else {
      api.reload('51016d2a', component.options)
    }
    module.hot.accept("./PageFile.vue?vue&type=template&id=51016d2a&", function () {
      api.rerender('51016d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/file/PageFile.vue"
export default component.exports